import { Phone, MessageCircle, Mail, Clock3, MapPin } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { CONTACT, waLink, BG } from "../lib/data";
import { useLang } from "../lib/i18n";
import { SectionBg } from "./SectionBg";

export default function Contact() {
  const { lang, t } = useLang();
  const ACTIONS = [
    {
      id: "phone",
      icon: Phone,
      label: t.contact.labels.phone,
      value: CONTACT.phoneDisplay,
      href: CONTACT.tel,
      testid: "contact-phone-link",
    },
    {
      id: "whatsapp",
      icon: MessageCircle,
      label: t.contact.labels.whatsapp,
      value: t.contact.chat,
      href: waLink(lang === "en" ? "Hi OGO! I'd like to book a service." : "హాయ్ OGO! సర్వీస్ బుక్ చేయాలనుకుంటున్నాను."),
      testid: "contact-whatsapp-link",
    },
    {
      id: "email",
      icon: Mail,
      label: t.contact.labels.email,
      value: CONTACT.email,
      href: `mailto:${CONTACT.email}`,
      testid: "contact-email-link",
    },
  ];

  return (
    <section id="contact" className="relative py-24 lg:py-32 overflow-hidden">
      <SectionBg src={BG.contact} opacity={0.34} position="center 30%" testid="contact-bg-image" />
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[700px] h-[420px] rounded-full bg-gold/8 blur-[160px] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <SectionHead align="center" tag={t.contact.tag} title={t.contact.title} sub={t.contact.sub} />

        <div className="grid sm:grid-cols-3 gap-5 mt-14">
          {ACTIONS.map(({ id, icon: Icon, label, value, href, testid }, i) => (
            <Reveal key={id} delay={0.08 * i} className="h-full">
              <a
                data-testid={testid}
                href={href}
                target={id === "whatsapp" ? "_blank" : undefined}
                rel={id === "whatsapp" ? "noreferrer" : undefined}
                className="group h-full flex flex-col items-center text-center rounded-3xl border border-white/10 bg-panel/70 p-9 hover:border-gold/50 hover:-translate-y-2 transition-all duration-500"
              >
                <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-gold/10 border border-gold/30 text-gold group-hover:scale-110 group-hover:bg-gold group-hover:text-ink transition-all duration-500">
                  <Icon size={22} strokeWidth={2.1} />
                </span>
                <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-slate-400 mt-6">{label}</p>
                <p className="font-display font-bold text-white text-lg mt-2 group-hover:text-gold transition-colors duration-300 break-all">
                  {value}
                </p>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-ink/70 px-5 py-3 font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.2em] text-slate-300">
              <Clock3 size={14} className="text-mint" /> {CONTACT.hours[lang]}
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-ink/70 px-5 py-3 font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.2em] text-slate-300">
              <MapPin size={14} className="text-gold" /> {CONTACT.area[lang]}
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
